import { format } from 'date-fns';
import useFindOrganizationsQuery from '@/api/queries/useFindOrganizationsQuery';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import Pagination from '@/components/Pagination';
import { SearchProps } from '@/components/search/useSearch';
import StatusActiveIndicator from '@/components/StatusActiveIndicator';
import { isStatusActive } from '@/models/Status';
import { OrganizationEditPath } from '@/modules/admin/paths';
import { getCountryName } from '@/utils/locale/getCountryName';
import { Link } from 'react-router-dom';

const OrganizationTable = ({ searchQuery, page = 1, onChangePage = () => {} }: SearchProps) => {
  const { organizations, isLoading, itemsPerPage } = useFindOrganizationsQuery(page, searchQuery);

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <table className={isLoading ? 'loading' : ''}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Country</th>
              <th>Created At</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {organizations.items.map((organization, index) => {
              if (!organization.id) return null;

              return (
                <tr key={index}>
                  <td>
                    <Link
                      to={OrganizationEditPath.withId(organization.id)}
                      className="text-blue-500 hover:underline"
                    >
                      {organization.name}
                    </Link>
                  </td>
                  <td>{getCountryName(organization.countryCode)}</td>
                  <td>
                    {organization.createdAt &&
                      format(new Date(organization.createdAt), 'd MMM yyyy')}
                  </td>
                  <td>
                    <StatusActiveIndicator isActive={isStatusActive(organization)} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {isLoading && (
          <div role="status" className="loader">
            <SpinnerIcon />
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </div>
      <div className="table-bottom">
        <Pagination
          currentPage={page}
          itemsPerPage={itemsPerPage}
          totalCount={organizations.totalCount || 0}
          estimatedTotalCount={organizations.estimatedTotalCount || 0}
          onClick={onChangePage}
        />
      </div>
    </div>
  );
};

export default OrganizationTable;
